export enum FlowType {
  ONBOARDING = 'Onboarding',
  AUTHENTICATION = 'Authentication',
  VALIDATION = 'Validation',
  RESET_PASSWORD = 'ResetPassword'
}
